import React, { Component } from "react";
import ExistingForms from "./ExistingForms";

class FormBuilderSidebar extends Component {
    state = {
        isExisting: true,
        formOptions: [
            { title: "Existing properties", className: "existing-forms" },
            { title: "Create new", className: "new-form" }
        ],
        activeTab: 0
    };

    switchTab = (index) => {
        this.setState({ activeTab: index })
        // 
        // this.setState(prev => {
        //     if(index == 0) {
        //         prev.isExisting = true;
        //     }
        //     if(index == 1){
        //         prev.isExisting = false;

        //     }
        //     prev.formOptions.map(opt => opt.isActive = !opt.isActive)
        //         return {formOptions:prev.formOptions, isExisting:prev.isExisting}
        // })
    }
    render() {

        const { formItems} = this.props;
        return (
            <div className="form-column formItems-container bg-gray-6 scroll-no-scrollbar h-100">
                {/* <div className="form-status">
                    {formOptions.map((opt, index) => {
                        const { className, title,  } = opt;
                        return (
                            <div
                                key={index}
                                onClick={() => this.switchTab(index)}
                                className={"form-title " + className}
                                style={{
                                    backgroundColor:
                                        index == this.state.activeTab
                                            ? "#fff"
                                            : "rgb(245, 240, 240)"
                                }}
                            >
                                {title}
                            </div>
                        );
                    })}
                </div> */}
                {/* {isExisting ? ( */}
                <ExistingForms
                    setShowStructures={this.props.setShowStructures}
                    formItems={formItems}
                    setElDragData={this.props.setElDragData}
                />
                {/* ) : null} */}
            </div>
        );
    }
}

export default FormBuilderSidebar;
